import { render, staticRenderFns } from "./ModalEditarAlta.vue?vue&type=template&id=1e45671d&"
import script from "./ModalEditarAlta.vue?vue&type=script&lang=ts&"
export * from "./ModalEditarAlta.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEditarAlta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports